export default "__VITE_ASSET__CkLRYTBo__"